import { lazy } from 'react';

export const Achievements = lazy(() => import('./Achievements.component'));
